import requestWithAuth from "../httpClient";
import { rootURL } from "../rootURL";

const balanceDayURL = `${rootURL}balance-day/`;

export function getBalanceDaysForOverviewRequest({
	yearFilter = "",
}: {
	yearFilter?: string;
} = {}) {
	return requestWithAuth("get", `${balanceDayURL}all?yearFilter=${yearFilter}`);
}

export const getBalanceTotalForCurrentMonthRequest = async () => {
	return requestWithAuth("get", `${balanceDayURL}current-month-total`);
};

export function getBalanceDaysForChartsRequest({
	yearFilter = "",
	monthFilter = "",
}: {
	yearFilter?: string | number;
	monthFilter?: string | number;
} = {}) {
	return requestWithAuth(
		"get",
		`${balanceDayURL}all?yearFilter=${yearFilter}&monthFilter=${monthFilter}`,
	);
}

export function getBalanceDaysForClientsRequest() {
	return requestWithAuth("get", `${balanceDayURL}clients-statistics`);
}

/**
 * The day's figure for the Show total dialog, totalled by the server.
 *
 * The dialog used to fetch the day's balance days above and add them up in the
 * browser, on its own idea of what the penalty does. So the day row disagreed
 * with the two month rows beneath it and with the same day on the charts. All
 * four now come off one formula on the server.
 */
export const getBalanceTotalForSelectedDateRequest = async (date: string) => {
	const response = await requestWithAuth(
		"get",
		`${balanceDayURL}selected-date-total?selected-date=${encodeURIComponent(date)}`,
	);
	return response.text;
};

export const getBalanceTotalForPreviousMonthRequest = async () => {
	const response = await requestWithAuth(
		"get",
		`${balanceDayURL}previous-month-total`,
	);
	return response.text;
};
